export const INITIALIZE_MENU = '@menu/initialize_page';
export const FIND_QUANTIDADE_REQUISICOES = '@menu/find_quantidade_requisicoes';
export const SET_QUANTIDADE_NOTIFICAOES = '@menu/set_quantidade_notificacoes';
export const SET_QUANTIDADE_AUTORIZACOES = '@menu/set_quantidade_autorizacoes';
export const SET_QUANTIDADE_ACORDOS_APROVADOS = '@menu/set_quantidade_acordos_aprovados';
export const FIND_QUANTIDADE_AUTORIZACOES = '@menu/find_quantidade_autorizacoes';
export const FIND_QUANTIDADE_ACORDOS_APROVADOS = '@menu/find_quantidade_acordos_aprovados';

export function initializePageAction(title) {
  return { type: INITIALIZE_MENU, title };
}

export function setQuantidadeNotificacoesAction(quantidade) {
  return { type: SET_QUANTIDADE_NOTIFICAOES, quantidade };
}

export function setQuantidadeAutorizacoesAction(quantidade) {
  return { type: SET_QUANTIDADE_AUTORIZACOES, quantidade };
}

export function setQuantidadeAcordosAprovadosAction(dados) {
  return { type: SET_QUANTIDADE_ACORDOS_APROVADOS, quantidade: dados };
}

export function findQuantidadeRequisicoesAction() {
  return { type: FIND_QUANTIDADE_REQUISICOES };
}

export function findQuantidadeAutorizacoesAction() {
  return { type: FIND_QUANTIDADE_AUTORIZACOES };
}

export function findQuantidadeAcordosAprovadosAction() {
  return { type: FIND_QUANTIDADE_ACORDOS_APROVADOS };
}
